import React from 'react'

interface AISearchIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const AISearchIcon: React.FC<AISearchIconProps> = ({
  color = '#000',
  gradient = false,
  width = 25,
  height = 22,
  alt = 'AI Search icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 25 22'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M4.096 2.478l.122-.474.122.474a2.25 2.25 0 001.619 1.618l.473.122-.473.122a2.25 2.25 0 00-1.62 1.619l-.121.473-.122-.473a2.25 2.25 0 00-1.619-1.62l-.473-.121.473-.122a2.25 2.25 0 001.62-1.618zM3.25.75C3.507-.25 4.929-.25 5.187.75l.363 1.415a1 1 0 00.72.72l1.415.364c1.001.257 1.001 1.679 0 1.937L6.27 5.55a1 1 0 00-.72.72l-.363 1.415c-.258 1.001-1.68 1.001-1.937 0L2.886 6.27a1 1 0 00-.72-.72L.751 5.187C-.25 4.929-.25 3.507.751 3.25l1.415-.364a1 1 0 00.72-.72L3.25.751zm2.285 12.808l.491-1.912.492 1.912a2.25 2.25 0 001.619 1.619l1.912.492-1.912.491a2.25 2.25 0 00-1.619 1.619l-.492 1.912-.491-1.912a2.25 2.25 0 00-1.62-1.619l-1.911-.491 1.912-.492a2.25 2.25 0 001.619-1.619zm-.477-3.165c.257-1.001 1.68-1.001 1.937 0l.734 2.854a1 1 0 00.719.72l2.854.733c1 .258 1 1.68 0 1.937l-2.854.734a1 1 0 00-.72.72l-.733 2.853c-.258 1.001-1.68 1.001-1.937 0l-.734-2.854a1 1 0 00-.72-.72l-2.853-.733c-1.001-.257-1.001-1.68 0-1.937l2.853-.734a1 1 0 00.72-.72l.734-2.853zm9.731 1.662a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm4.565-1.003a5.75 5.75 0 10-.864.904l4.757 4.757.884-.884-4.777-4.777z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default AISearchIcon
